<script>
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import {
    playerState,
    updatePreviewEvent,
} from "@app/store/playerStore.svelte.js";
import { lockState } from "@app/store/lockStore.svelte.js";
import { styleState } from "@app/store/styleStore.svelte.js";

function getEvent() {
    if (playerState.playing) {
        updatePreviewEvent(getEventByTime(playerState.time));

        /* Scroll to and select the event if caption lock is enabled */
        if (
            lockState.caption &&
            playerState.previewEvent !== -1 &&
            eventGroupState[projectState.selected].selected[0] !==
                playerState.previewEvent
        ) {
            eventGroupState[projectState.selected].selected = [
                playerState.previewEvent,
            ];

            const selectedIndex =
                eventGroupState[projectState.selected].selected[0];

            // Dispatch custom event to scroll to the selected event
            window.dispatchEvent(
                new CustomEvent("scrollToVirtualListItem", {
                    detail: { index: selectedIndex },
                }),
            );
        }
    } else {
        updatePreviewEvent(eventGroupState[projectState.selected]?.selected[0]);
    }
}

function getEventByTime(sec) {
    return eventGroupState[projectState.selected].events.findIndex((event) => {
        return event.start <= sec && event.end >= sec;
    });
}

function decToHex(value) {
    return Math.floor((value / 100) * 255)
        .toString(16)
        .padStart(2, "0");
}

$effect(() => {
    // console.log("EFFECT Get Event Called by SubtitlePreview.svelte");
    getEvent(
        playerState.time,
        eventGroupState[projectState.selected]?.selected[0],
    );
});
</script>

<!-- horizontal alignmnet: justify-content-start, justify-content-center, justify-content-end -->
<!-- vertical alignmnet: align-items-start, align-items-center, align-items-end -->

{#if lockState.preview && eventGroupState[projectState.selected]?.events[playerState.previewEvent]}
    <div
        id="SubtitlePreviewWrapper"
        class="d-flex justify-content-start align-items-end">
        <div
            id="SubtitlePreview"
            class="textPreview"
            style="direction: {eventGroupState[projectState.selected].rtl
                ? 'rtl'
                : 'ltr'}; font-family: {styleState.ccMode
                ? eventGroupState[projectState.selected]?.fontFamily
                : styleState.fontFamily}; font-size: {styleState.ccMode
                ? eventGroupState[projectState.selected]?.fontSize
                : styleState.fontSize}px; color: {styleState.ccMode ? "#ffffff" : styleState.color +
                decToHex(styleState.opacity)};
                background: {styleState.ccMode ? '#000000' : styleState.outlineColor};
                line-height: 110%;
                letter-spacing: {styleState.ccMode ? 4 : styleState.spacing}px;
                {styleState.borderStyle == '1' && !styleState.ccMode
                ? `text-shadow: ${styleState.shadow}px ${styleState.shadow}px 3px ${styleState.shadowColor + decToHex(styleState.shadowOpacity)}; 
      -webkit-text-stroke: ${styleState.outline}px ${styleState.outlineColor + decToHex(styleState.outlineOpacity)};
      background: none;`
                : !styleState.ccMode ? `background: ${styleState.outlineColor + decToHex(styleState.outlineOpacity)}; padding: ${styleState.outline}px` : ''};
                text-align: {eventGroupState[projectState.selected].events[
                playerState.previewEvent
            ].alignment};">
            {@html eventGroupState[projectState.selected].events[
                playerState.previewEvent
            ].text}
        </div>
    </div>
{/if}

<style>
#SubtitlePreviewWrapper {
    z-index: 9999;
    position: absolute;
    pointer-events: none;
    overflow: hidden;
    height: 100%;
    width: 100%;
    top: 0;
}

#SubtitlePreview {
    position: relative;
    user-select: none;
}
</style>
